import { takeEvery, put } from 'redux-saga/effects';
import { BAD_REQUEST } from 'http-status-codes';

import {
  API_ERROR_ASK_FOR_RESET_EMAIL,
  API_ERROR_LOGIN,
  API_ERROR_SET_PASSWORD,
  API_COMMON_ERROR,
  API_EXPERIENCE_ERROR
} from 'src/app/redux/actions/apiError';
import alerts from 'src/app/alerts.json';
import { feedbackMessageShow } from 'src/app/redux/actions/feedbackMessage';
import { transclusionFromNewPassword } from 'src/app/redux/actions/transclusion';
import { firstLetterLowercase } from 'src/app/api/camelize';


function* offlineOrInternalError(response) {
  const { userOffline, internalError } = alerts;

  if (!response) {
    return yield put(feedbackMessageShow(userOffline));
  }
  if (response.status!==BAD_REQUEST) {
    return yield put(feedbackMessageShow(internalError));
  }

  return yield false;
}

function* handleAskForResetEmailError({ payload }) {
  const { response } = payload;
  yield offlineOrInternalError(response);
}

function* handleLoginError({ payload }) {
  const { response } = payload;

  if (yield offlineOrInternalError(response)) {
    return;
  }
  const { tooManyRequestsOrBadPassword } = alerts;

  if (response && response.status===BAD_REQUEST) {
    yield put(feedbackMessageShow(tooManyRequestsOrBadPassword));
  }
}

function* handleSetPasswordError({ payload }) {
  const { internalError } = alerts;
  const { response } = payload;

  if (yield offlineOrInternalError(response)) {
    return;
  }
  const { data } = firstLetterLowercase(response);

  if (!Array.isArray(data) || data.length===0) {
    yield put(feedbackMessageShow(internalError));
    return;
  }

  const validationErrors = data.map(({ statusCode }) => ({ statusCode }));
  yield put(transclusionFromNewPassword(validationErrors));
}

const handleApiError = (transformErrorsToDescriptionCallback) => function* handleCommonErrors({ payload }) {
  const { internalError } = alerts;
  const { response } = payload;

  if (!response) {
    return yield put(feedbackMessageShow(internalError));
  }
  const { data } = firstLetterLowercase(response);

  if (!Array.isArray(data) || data.length===0) {
    return yield put(feedbackMessageShow(internalError));
  }

  const validationErrors = {
    template: 'error',
    icon: 'error',
    description: transformErrorsToDescriptionCallback(data)
  };

  return yield put(feedbackMessageShow(validationErrors));
};

const handleCommonErrors = handleApiError((data) =>
  data
    .map(({ message }) => message)
    .reduce(() => [(previous, current) => [previous, '.\n', current]])
);

const handleExperienceFormErrors = handleApiError((data) =>
  data
    .map(({ validationError }) => validationError.message)
    .reduce(() => [(previous, current) => [previous, '.\n', current]])
);


export default [
  takeEvery(API_ERROR_ASK_FOR_RESET_EMAIL, handleAskForResetEmailError),
  takeEvery(API_ERROR_SET_PASSWORD, handleSetPasswordError),
  takeEvery(API_ERROR_LOGIN, handleLoginError),
  takeEvery(API_COMMON_ERROR, handleCommonErrors),
  takeEvery(API_EXPERIENCE_ERROR, handleExperienceFormErrors)
];
